import { NgModule } from '@angular/core';
import { CommonModule } from '@nano/common';
import { CollapseModule } from '@nano/common/collapse';
import { AddressTypeModule, BankCodeTypeModule, CountryModule } from '@nano/common/classifier';
import { PartyIdentificationModule } from '@nano/common/party-identification';

import { PaymentAdditionalInfoIdentificationComponent } from './payment-additional-info-identification/payment-additional-info-identifiation.component';
import { PaymentAdditionalInfoComponent } from './payment-additional-info.component';

@NgModule({
  imports: [CommonModule, CollapseModule, CountryModule, PartyIdentificationModule, AddressTypeModule, BankCodeTypeModule],
  declarations: [PaymentAdditionalInfoIdentificationComponent, PaymentAdditionalInfoComponent],
  exports: [PaymentAdditionalInfoComponent]
})
export class PaymentAdditionalInfoModule {}
